const recaptchaVerificationThresholdScore = (): number | undefined => {
    switch (window['environment']['name']) {
        case 'production':
            return 0.8;
        case 'staging':
        case 'development':
            return 0.4;
        default:
            return undefined;
    }
};

export default recaptchaVerificationThresholdScore;
